<template>
  <footer class="bg-neutral-800 text-white pt-12 pb-6">
    <div class="container mx-auto px-4">
      <!-- 页脚内容 -->
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
        <!-- 关于我们 -->
        <div>
          <h3 class="text-lg font-semibold mb-4">关于我们</h3>
          <ul class="space-y-2">
            <li><router-link to="/about-us" class="hover:text-primary transition-colors">公司简介</router-link></li>
            <li><router-link to="/about-us#team" class="hover:text-primary transition-colors">我们的团队</router-link></li>
            <li><router-link to="/about-us#careers" class="hover:text-primary transition-colors">加入我们</router-link></li>
            <li><router-link to="/about-us#news" class="hover:text-primary transition-colors">新闻中心</router-link></li>
          </ul>
        </div>
        
        <!-- 客户服务 -->
        <div>
          <h3 class="text-lg font-semibold mb-4">客户服务</h3>
          <ul class="space-y-2">
            <li><router-link to="/contact-us" class="hover:text-primary transition-colors">联系我们</router-link></li>
            <li><router-link to="/faq" class="hover:text-primary transition-colors">常见问题</router-link></li>
            <li><router-link to="/refund-policy" class="hover:text-primary transition-colors">退款政策</router-link></li>
            <li><router-link to="#" class="hover:text-primary transition-colors">配送信息</router-link></li>
          </ul>
        </div>
        
        <!-- 法律信息 -->
        <div>
          <h3 class="text-lg font-semibold mb-4">法律信息</h3>
          <ul class="space-y-2">
            <li><router-link to="/terms-of-service" class="hover:text-primary transition-colors">用户条款</router-link></li>
            <li><router-link to="/privacy-policy" class="hover:text-primary transition-colors">隐私政策</router-link></li>
            <li><router-link to="/cookie-policy" class="hover:text-primary transition-colors">Cookie政策</router-link></li>
            <li><router-link to="#" class="hover:text-primary transition-colors">知识产权</router-link></li>
          </ul>
        </div>
        
        <!-- 联系我们 -->
        <div>
          <h3 class="text-lg font-semibold mb-4">联系我们</h3>
          <ul class="space-y-3">
            <li class="flex items-start">
              <i class="fa fa-map-marker text-primary mt-1 mr-3"></i>
              <span>北京市朝阳区建国路88号</span>
            </li>
            <li class="flex items-center">
              <i class="fa fa-phone text-primary mr-3"></i>
              <span>400-123-4567</span>
            </li>
            <li class="flex items-center">
              <i class="fa fa-envelope-o text-primary mr-3"></i>
              <span>service@eliteshop.com</span>
            </li>
          </ul>
          
          <!-- 社交媒体 -->
          <div class="mt-6 flex space-x-4">
            <router-link to="#" class="w-10 h-10 rounded-full bg-neutral-700 hover:bg-primary flex items-center justify-center transition-colors">
              <i class="fa fa-weixin"></i>
            </router-link>
            <router-link to="#" class="w-10 h-10 rounded-full bg-neutral-700 hover:bg-primary flex items-center justify-center transition-colors">
              <i class="fa fa-weibo"></i>
            </router-link>
            <router-link to="#" class="w-10 h-10 rounded-full bg-neutral-700 hover:bg-primary flex items-center justify-center transition-colors">
              <i class="fa fa-instagram"></i>
            </router-link>
            <router-link to="#" class="w-10 h-10 rounded-full bg-neutral-700 hover:bg-primary flex items-center justify-center transition-colors">
              <i class="fa fa-facebook"></i>
            </router-link>
          </div>
        </div>
      </div>
      
      <!-- 订阅 -->
      <div class="border-t border-neutral-700 pt-8 mb-8">
        <div class="flex flex-col md:flex-row items-center justify-between">
          <h3 class="text-lg font-semibold mb-4 md:mb-0">订阅我们的新闻资讯</h3>
          <div class="flex w-full md:w-auto">
            <input type="email" placeholder="您的邮箱地址" 
                   class="px-4 py-2 rounded-l-lg w-full md:w-64 focus:outline-none text-neutral-800">
            <button class="bg-primary hover:bg-primary/90 text-white px-6 py-2 rounded-r-lg transition-colors">
              订阅
            </button>
          </div>
        </div>
      </div>
      
      <!-- 版权信息 -->
      <div class="border-t border-neutral-700 pt-6 text-center text-sm text-neutral-400">
        <p>© 2025 EliteShop 电商平台 版权所有 | 京ICP备12345678号</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>